export default __webpack_public_path__ + "static/EPAM_LOGO_Primary-2cbf58dbe7d45b9a492412405ff8573f.png";